import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import { Button, Input, Icon, Flag, Popup, Dropdown } from 'semantic-ui-react';
import { ReviewRefundRequestModal } from '../../components';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import { sortPriorities, defaultSort, enums } from '../../helpers';
import { invert } from 'lodash';
import config from '../../config';

import "semantic-ui-css/components/button.min.css";
import "semantic-ui-css/components/label.min.css";
import "semantic-ui-css/components/input.min.css";
import "semantic-ui-css/components/icon.min.css";

import "../../react-table.css";
import './RefundApprover.css';

export default class RefundRequestor extends Component {
  static propTypes = {
    fetchRefundData: PropTypes.func,
    notifyUser: PropTypes.func,
    refunds: PropTypes.array,
    addComment: PropTypes.func,
    showModal: null
  };

  constructor(props) {
    super(props);
    this.state = {
      msisdn: null
    }
  }

  componentDidMount() {
    const { msisdn } = this.state;
    this.props.getRefundData({ msisdn });
    this.props.getOperatorData();
  }

  onMsisdnChange = (e, {value}) => {
    this.props.getRefundData({ msisdn: value })
    this.setState({msisdn: value})
  }

  clearMsisdn = () => {
    this.setState({ msisdn: '' });
    this.props.getRefundData({ msisdn: ''})

  }

  copy = (textToCopy) => (e) => {
    e.stopPropagation();
    copy(textToCopy);
    this.props.notifyUser({
      message: `"${textToCopy}" copied!`,
      type: 'success'
    });
  }

  toggleModal = (caseId) => caseId ? this.setState({ showModal: caseId }) : this.setState({ showModal: false })

  togglePreviewModal = (caseId) => caseId ? this.setState({ showPreviewModal: caseId }) : this.setState({ showPreviewModal: false })

  closeModal = () => this.setState({ showModal: false })

  closePreviewModal = () => this.setState({ showPreviewModal: false })

  onFilterChange = (field) => (value, callback) => this.setState({[field]: value}, () => callback(value))

  render() {
    const countries = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryISO]: operator.countryName
    }), {}) : {};

    const countryIdToISO = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryISO
    }), {}) : {};

    const ocToName = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.oc]: operator.operatorName
    }), {}) :{};

    const operators = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.operatorName]: operator.operatorName
    }), {}) :{};

    const countriesToEntities = this.props.operators ? this.props.operators.reduce((acc, curr) => ({
      ...acc,
      [curr.countryISO]: Array.from(new Set([
        ...(acc[curr.countryISO] ? acc[curr.countryISO] : []),
        ...curr.services.map(service => service.entity)
      ]))
    }), {}) : {};

    const countryOptions = Object
      .keys(countries)
      .filter(country => this.props.refunds.map(refund => countryIdToISO[refund.countryId]).includes(country))
      .map(countryId => ({ key: countryId, value: countryId, text: countries[countryId] }))
      .filter(country => !this.state.entity || countriesToEntities[country.key].includes(this.state.entity))
      .filter(country => !this.state.operator || this.props.operators.find(operator => operator.countryISO === country.key && operator.operatorName === this.state.operator))
      .filter(country => !this.state.method || countriesToEntities[country.key].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))

    const operatorOptions = Object
      .keys(operators)
      .filter(operator => this.props.refunds.map(refund => ocToName[refund.oc]).includes(operator))
      .filter(operator => !this.state.entity || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.operatorName === operator).countryISO].includes(this.state.entity))
      .filter(operator => !this.state.country || this.props.operators.find(operatorObj => operatorObj.operatorName === operator && operatorObj.countryISO === this.state.country))
      .filter(operator => !this.state.method || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.operatorName === operator).countryISO].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))
      .map(operator => ({ key: operator, value: operator, text: operator }));

    const entityOptions = Object
      .keys(enums.entityToRefundMethod)
      .filter(entity => !this.state.method || (enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][invert(enums.refundMethods)[this.state.method]] : false))
      .filter(entity => !this.state.country || countriesToEntities[this.state.country].includes(entity))
      .filter(entity => !this.state.operator || countriesToEntities[this.props.operators.find(operator => operator.operatorName === this.state.operator).countryISO].includes(entity))
      .filter(entity => this.props.refunds.map(item => item.entity).includes(entity))
      .map(entity => ({ key: entity, value: entity, text: entity }));

    return (
      <div className="RefundApprover main-content">
          <div className="RefundFilters">
              <div className="main-title">
                  Review Refunds
                  <span className="main-title__length"> {this.props.refunds.length}</span>
              </div>
              <div className="main-toolbar">
                  <div className="main-toolbar_item">
                      <Input
                          onChange={this.onMsisdnChange}
                          icon={this.state.msisdn && this.state.msisdn.length ? <Icon name='remove' inverted circular link size="tiny" onClick={this.clearMsisdn} /> : null}
                          placeholder="MSISDN Lookup"
                          value={this.state.msisdn}
                      />
                  </div>
              </div>
          </div>
        <ReactTable
          data={this.props.refunds.slice().sort(sortPriorities).map(refund => ({
            ...refund,
            priority: refund.priority === 'HIGH' ? <Icon name="angle double up" color="red" /> : <Icon name="angle double down" color="green" />,
            priorityValue: refund.priority,
            createdAt: moment(refund.createdAt).format('YYYY-MM-DD HH:mm'),
            updatedAt: moment(refund.updatedAt).format('YYYY-MM-DD HH:mm'),
            country: this.props.operators && this.props.operators.length ? <span><Flag name={this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO.toLowerCase()} /> {this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO}</span> : null,
            countryISO: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO : null,
            operator: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).operatorName : null,
            service: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).services.find(service => refund.srvcId.toString() === service.id).name : null,
            msisdnWithCopy: <span>
              <Popup
                trigger={<Button size="mini" className="button-copy" icon="clone" circular onClick={this.copy(refund.msisdn)} />}
                content="Copy"
                inverted
                size="mini"
                position="bottom center"
              /> {refund.msisdn}
            </span>,
            idWithCopy: <span>
              <Popup
                trigger={<Button size="mini" className="button-copy" icon="clone" circular onClick={this.copy(refund._id)} />}
                content="Copy"
                inverted
                size="mini"
                position="bottom center"
              /> {refund._id}
            </span>,
            zendeskAction: <div style={{textAlign: 'center'}}>
                <Popup
                    trigger={<Button size="mini" className="button-approve" icon='external alternate' compact onClick={(e) => {
                      e.stopPropagation();
                      const win = window.open(`${config.zendeskURL}agent/tickets/${refund.zendeskTicket}`);
                      win.focus();
                    }}/>}
                    content="Open in Zendesk"
                    inverted
                    size="mini"
                    position="bottom center"
                />
            </div>
          }))}
          columns={[
            {
              Header: () => <span>Priority</span>,
              width: 65,
              accessor: 'priority',
              filterable: true,
              filterMethod: ({value}, row) => value === row._original.priorityValue,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Priority"
                fluid
                search
                options={[
                  {key: '', value: '', text: 'Select All'},
                  {
                    key: "HIGH",
                    value: "HIGH",
                    text: <span className="priority-icon-form"><Icon name="angle double up" color="red" /> High</span>
                  }, {
                    key: "NORMAL",
                    value: "NORMAL",
                    text: <span className="priority-icon-form"><Icon name="angle double down" color="green" />Normal</span>
                  }
                ]}
                onChange={(e, {value}) => onChange(value)}
                value={ filter ? filter.value : '' }
              />
            },
            { Header: 'Case ID', accessor: 'idWithCopy' },
            { Header: () => <span>Created</span>, width: 145, accessor: 'createdAt' },
            {
              Header: () => <span>Country</span>,
              width: 75,
              accessor: 'country',
              sortMethod: (a, b) => defaultSort(a.props.children[2], b.props.children[2]),
              filterable: true,
              filterMethod: ({value}, row) => value === row._original.countryISO,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Country"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...countryOptions]}
                onChange={(e, {value}) => this.onFilterChange('country')(value, onChange)}
                value={ filter ? filter.value : '' }
              />

            },
            {
              Header: 'Operator',
              accessor: 'operator',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Operator"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...operatorOptions]}
                onChange={(e, {value}) => this.onFilterChange('operator')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Entity',
              accessor: 'entity',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Entity"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...entityOptions]}
                onChange={(e, {value}) => this.onFilterChange('entity')(value, onChange)}
                value={ filter ? filter.value : '' }
              />

            },
            { Header: 'Service', accessor: 'service' },
            {Header: () => <span>Number</span>,
                width: 130, accessor: 'msisdnWithCopy', sortMethod: (a, b) => defaultSort(a.props.children[2], b.props.children[2]) },
            {Header: () => <span>Status</span>,
                width: 115, accessor: 'status'},
            {Header: () => <span>Updated</span>,
                width: 145, accessor: 'updatedAt'},
            {
              Header: () => <span>Zendesk</span>,
              width: 65,
              accessor: 'zendeskAction',
              Filter: () => <span className="default text"></span>
            }
          ]}
          defaultPageSize={10}
          className="RefundApproverTable -striped"
          getTrProps={(state, rowInfo) => {
            return {
              onClick: (e) => rowInfo.original.status === 'REQUESTED' ? this.toggleModal(rowInfo.original._id) : this.togglePreviewModal(rowInfo.original._id),
              style: {
                cursor: rowInfo ? 'pointer' : null
              }
            }
          }}
          getLoadingProps={() => ({
              loadingText:
                  <div className="loading-widget loading-widget_table">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <g fill="none" fill-rule="evenodd">
                              <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                              <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                          </g>
                      </svg>
                  </div>
          })}
          getPaginationProps={() => ({
              nextText: <Icon name="icon1 icon1_angle-right"  />,
              previousText: <Icon name="icon1 icon1_angle-left" />
          })}
          loading={this.props.loading}
        />
        <ReviewRefundRequestModal
          initialValues={this.props.refunds.find(refund => refund._id === this.state.showModal)}
          open={this.state.showModal}
          close={this.closeModal}
          refundCount={this.props.refundCount}
          getRefundsCount={this.props.getRefundsCount}
          updateStatus={this.props.updateStatus}
          addComment={this.props.addComment}
          operators={this.props.operators}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
          loadingTransactions={this.props.loadingTransactions}
          switch={this.props.switch}
          switching={this.props.switching}
        />
        <ReviewRefundRequestModal
          initialValues={this.props.refunds.find(refund => refund._id === this.state.showPreviewModal)}
          open={this.state.showPreviewModal}
          refundCount={this.props.refundCount}
          getRefundsCount={this.props.getRefundsCount}
          close={this.closePreviewModal}
          addComment={this.props.addComment}
          operators={this.props.operators}
          uploadFiles={this.props.uploadFiles}
          uploading={this.props.uploading}
          type="requestor"
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
          loadingTransactions={this.props.loadingTransactions}
          switch={this.props.switch}
          switching={this.props.switching}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RefundApproverRouteComponent/RefundApprover.js